module.exports = __webpack_public_path__ + "img/icon-whatsapp.097badc1.svg";